module.exports = __webpack_public_path__ + "static/img/baccarat2_th.1be6356.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/baccarat2_th.png
// module id = Z0gN
// module chunks = 1